import { render, staticRenderFns } from "./migrationangsuran.vue?vue&type=template&id=704d80e8&scoped=true&"
import script from "./migrationangsuran.vue?vue&type=script&lang=js&"
export * from "./migrationangsuran.vue?vue&type=script&lang=js&"
import style0 from "./migrationangsuran.vue?vue&type=style&index=0&id=704d80e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d80e8",
  null
  
)

export default component.exports